const IOS =
  typeof navigator !== "undefined" &&
  /iPad|iPhone|iPod/.test(navigator.userAgent) &&
  !window.MSStream;

export const canChangeVideoVolume = !IOS;
export const canVideoFullscreen = IOS;
